import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { NgStyle, TitleCasePipe } from '@angular/common';

@Component({
  standalone: true,
  imports: [NgStyle, TitleCasePipe],
  selector: 'button-renderer',
  template: `
    <span class="inline-flex items-center">
      <span class="w-2 h-2 rounded-full mr-2" [ngStyle]="{ backgroundColor: color }"></span>
      <span class="pr-2px leading-relaxed whitespace-nowrap"> {{ params.value | titlecase }}</span>
    </span>
  `,
})
export class TableStatusRenderer implements ICellRendererAngularComp {
  params;
  color: string;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.color = this.getStatusColor(params.value);
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    this.color = this.getStatusColor(params.value);
    return true;
  }

  getStatusColor(status: string): string {
    return this.params?.statusColors?.[status] || 'black';
  }
}
